import React, { useMemo } from 'react';
import DataTable from '../../../../Components/Base/DataTable';
import {
	QuestionnaireResultItem,
	useQuestionnaireResultItemsQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import useTranslation from '../../../../Hooks/useTranslation';
import FormattedDate from '../../../../Components/FormattedDate';

interface Props {
	patientId: string;
}

const HealthPlanBabyCzechEndResult: React.FC<Props> = ({ patientId }) => {
	const { t } = useTranslation();
	const { data, isLoading } = useQuestionnaireResultItemsQuery({
		questionnaireCode: 'meddibaby_end_questionnaire',
		patientId,
		take: 9999,
	});

	const parsedData = useMemo(() => {
		const temp: any[] = [];

		const apgar: string[] = [];

		data?.questionnaireResultItems?.data?.map(
			(questionnaireResultItem: QuestionnaireResultItem) => {
				const key = questionnaireResultItem.question?.key;

				if (key === 'birthMethod.value') {
					return;
				}

				let value =
					typeof questionnaireResultItem.valueJson?.rawValue !== 'undefined'
						? questionnaireResultItem.valueJson?.rawValue
						: questionnaireResultItem.valueJson;

				if (
					[
						'apgar.first.value',
						'apgar.second.value',
						'apgar.third.value',
					].includes(key)
				) {
					apgar.push(value);
				}

				let label = `base.${questionnaireResultItem.question?.key}`;

				if (key === 'birthAdditionalInformation') {
					label = `base.additionalInformation`;
				}
				if (key === 'birthMethod.label') {
					label = `base.birthMethod`;
				}

				if (
					[
						'courseOfChildBirthBaby',
						'courseOfChildBirthMother',
						'birthOfChild',
					].includes(key)
				) {
					value = t(`base.${value}`);
				}

				if (key === 'birthDate') {
					value = <FormattedDate date={value} />;
				} else if (key === 'newbornHeight') {
					value = `${value} cm`;
				} else if (key === 'newbornWeight') {
					value = `${value} g`;
				}

				temp.push({
					key,
					label,
					value,
				});
			},
		);

		if (apgar.length) {
			temp.push({
				key: 'apgar',
				label: 'Apgar skóre',
				value: apgar.join(' - '),
			});
		}

		const sortKeys = [
			'birthPlace',
			'birthDate',
			'birthWeek',
			'birthMethod',
			'courseOfChildBirthMother',
			'courseOfChildBirthBaby',
			'birthOfChild',
			'newbornWeight',
			'newbornHeight',
			'apgar',
			'birthAdditionalInformation',
		];

		const sortedTemp: any[] = [];
		sortKeys.map(key => {
			const item = temp.find(({ key: itemKey }) => itemKey === key);
			if (item) {
				sortedTemp.push(item);
			}
		});

		return sortedTemp;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<DataTable>
			{parsedData.map(({ label, value, key }) => (
				<DataTable.Row key={key} label={label} value={value} />
			))}
		</DataTable>
	);
};

export default HealthPlanBabyCzechEndResult;
